import {WIX_ECOM} from '@wix/app-definition-ids';
import {EditorSDK} from '@wix/platform-editor-sdk';

export async function getEcomPages(sdk: EditorSDK) {
  const ecomApplicationId = (await sdk.tpa.app.getDataByAppDefId('', WIX_ECOM)).applicationId;
  const allSitePages = await sdk.pages.data.getAll('');
  return allSitePages.filter((page) => page.tpaApplicationId === ecomApplicationId);
}
